import { PageNames } from '../../Constants/PagesRoutes/PageURLs'
import ContainerListing from '../../Pages/ManageContainer'
export default function TrayRankingList() {
  return <ContainerListing entryPoint={PageNames.TrayRanking} />
}
